/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorCounseling,
  PharmacyCounselorCounselingFromJSON,
  PharmacyCounselorCounselingFromJSONTyped,
  PharmacyCounselorCounselingToJSON,
} from "./";

export const PharmacyCounselorCounselingsTypename = "PharmacyCounselorCounselings" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorCounselings
 */
export interface PharmacyCounselorCounselings {
  /**
   *
   * @type {Array<PharmacyCounselorCounseling>}
   * @memberof PharmacyCounselorCounselings
   */
  counselings: Array<PharmacyCounselorCounseling>;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorCounselings
   */
  count?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorCounselings
   */
  readonly __typename?: string;
}

export function PharmacyCounselorCounselingsFromJSON(json: any): PharmacyCounselorCounselings {
  return PharmacyCounselorCounselingsFromJSONTyped(json, false);
}

export function PharmacyCounselorCounselingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorCounselings {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorCounselingsTypename,

    counselings: (json["counselings"] as Array<any>).map(PharmacyCounselorCounselingFromJSON),
    count: !exists(json, "count") ? undefined : json["count"],
  };
}

export function PharmacyCounselorCounselingsToJSON(object?: PharmacyCounselorCounselings | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counselings: (value.counselings as Array<any>).map(PharmacyCounselorCounselingToJSON),
    count: value.count,
  };
}
